import React from 'react';
import { Box, Button, Grid } from '@mui/material';
import { useDispatch } from 'react-redux';

import KPTextfield from '../KPTextfield/KPTextfield';

import { userActions } from '../../../actions';
import { dateFormatter } from '../../../utils';
import { jumpToReleventDiv } from '../../../utils/anim';
import { getError, getValue } from './utils';

export const KPTYPE = {
  date: 'date',
  text: 'text',
  int: 'int',
  json: 'json',
  float: 'float',
  submit: 'submit',
  email: 'email',
  render: 'render',
  button: 'button',
  select: 'select',
  checkbox: 'checkbox',
  richtext: 'richtext',
  dropzone: 'dropzone',
  radio: 'radio',
  textarea: 'textarea',
  selectAdd: 'selectAdd',
}

export const DEFAULT_ERROR = { key: null, value: null }

function KPTextform({
  values = {},
  setValues,
  textForm = [],
  component = 'form',
  ...props
}) {
  const dispatch = useDispatch();
  const [error, setError] = React.useState({ ...DEFAULT_ERROR });

  const handleChangeForm = (name, event, type) => {
    var value;
    // console.log(name, event, type);
    switch (type) {
      case KPTYPE.int:
        value = parseInt(event.target.value);
        break;
      case KPTYPE.float:
        value = parseFloat(event.target.value);
        break;
      case KPTYPE.selectAdd:
        // console.log('selectAdd', event);
        value = (event.target.textContent || event.target.textContent === "") ? event.target.textContent : event.target.value;
        break;
      case KPTYPE.date:
      case KPTYPE.dropzone:
      case KPTYPE.richtext:
        value = event;
        break;
      case KPTYPE.checkbox:
        value = event.target.checked;
        break;
      default:
        value = event.target.value;
        break;
    }
    
    const keys = name.split('.');
    const lastKey = keys.pop();
    const newValues = { ...values };

    var nestedObj = newValues;
    keys.forEach(k => {
      if (!nestedObj[k]) nestedObj[k] = {};
      nestedObj = nestedObj[k];
    });
    nestedObj[lastKey] = value;
    // console.log('newValues', lastKey, value,newValues);

    setValues(newValues);

    // console.log('handleChangeForm', props.error, name, value, type, error.key);
  
    if (error.key === name) setError({ ...DEFAULT_ERROR });
    if (props.error && props.error.key === name) {
      // console.log('here !!!');
      setError({ key: props.error.key, value: null });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const formattedValues = { ...values };

    for (const elm of textForm) {
      const err = getError(values, elm);
      if (!!err) {
        setError({ key: elm.key, value: err });
        jumpToReleventDiv(elm.key);
        dispatch(userActions.notification({
          message: `Không được để trống thông tin về: ${elm.label}`,
          type: 'error'
        }));
        return;
      }

      if (elm.type === KPTYPE.date) {
        formattedValues[elm.key] = dateFormatter(formattedValues[elm.key]);
      }
    }
    // console.log('Submitting form with values:', formattedValues, event);

    props.handleSubmit(formattedValues);
  }

  const formError = props.error || error;

  // if (textForm[0].key === 'generalScientificReportProof') {
  //   console.log(formError, 'formError');
  // }

  return (
    <Box id={props.id} component={component} onSubmit={handleSubmit}>
      <Grid container spacing={1}>
        {textForm.map((elm) => (
          <Grid item key={elm.key} xs={elm.xs} md={elm.md}>
            {elm.type === KPTYPE.dropzone && (
              <Box sx={{ mb: 2 }} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button
                  variant="contained"
                  component="label"
                  color="primary"
                  size="small"
                  // disabled={getValue(values, elm) ? false : true}
                  onClick={() => {
                    // console.log(elm, values[`${elm.key}_tmp`], values);
                    const file = values[`${elm.key}_tmp`];
                    // console.log(file);
                    if (file) {
                      props.setPreview(file);
                    }
                  }}
                >
                  Preview
                </Button>
              </Box>
            )}
            <KPTextfield
              {...elm}
              key={undefined}
              values={elm.type === KPTYPE.render ? values : undefined}
              id={elm.key}
              disabled={elm.disabled || false}
              value={getValue(values, elm)}
              error={error.key === elm.key ? error.value : (formError.key === elm.key) ? formError.value : null}
              handleChangeForm={props.handleChangeForm || handleChangeForm}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
}

export default KPTextform;
